import * as React from 'react';
import { ModalContainer } from '@here/hds-modal';
// eslint-disable-next-line no-new
new ModalContainer();
const HDSModalContainer = React.forwardRef((props, ref) => {
    const { children, className, ...rest } = props;
    return (React.createElement("hds-modal-container", { ...(className && { class: className }), ref: ref, ...rest }, children));
});
export default HDSModalContainer;
//# sourceMappingURL=HDSModalContainer.js.map